import { useNavigate } from 'react-router';

import { CasDisplayField, CasErrorDisplay, CasStackRow } from 'src/compass/shared/components';
import CasRefreshButton from 'src/compass/shared/components/CasButton/CasRefreshButton';
import CasLoader from 'src/compass/shared/components/CasLoader/CasLoader';
import useRetrieve from 'src/compass/shared/hooks/reactQuery/useRetrieve';
import { ClaimStatusFilter_NotDoneOrAttached } from '../shared/ClaimListing/ClaimListing';

export default function DashboardTab() {
  const queryResult = useRetrieve({ url: 'Sce/Claims/Dashboard' });
  const navigate = useNavigate();

  const { data, isFetching, isError, refetch } = queryResult;

  if (isFetching) return <CasLoader />;

  if (isError) return <CasErrorDisplay message="Error retrieving data from the server." />;

  const {
    noticeMissingCount,
    reviewUploadsCount,
    sendCount,
    docusignReviewCount,
    callbackCount,
    tenDaysLeftCount,
  } = data;

  const baseUrl = '/endorsements/claimtracking';

  return (
    <CasStackRow alignItems="center">{/* Temporary for now to remove CasDisplayField margin-bottom */}
      <div>
        <CasDisplayField
          horizontal 
          label="Notice Missing"
          value={noticeMissingCount}
          onClick={() => navigate(`${baseUrl}/todo/noticeMissing`)}
        />
        <CasDisplayField
          horizontal 
          label="Review Uploads"
          value={reviewUploadsCount}
          onClick={() => navigate(`${baseUrl}/todo/fwdContracts/review`)}
        />
        <CasDisplayField
          horizontal
          label="Send"
          value={sendCount}
          onClick={() => navigate(`${baseUrl}/todo/send`)}
        />
        <CasDisplayField
          horizontal
          label="Docusign Review"
          value={docusignReviewCount}
          onClick={() => navigate(`${baseUrl}/todo/docusignReview`)}
        />
        <CasDisplayField
          horizontal
          label="Callback"
          value={callbackCount}
          onClick={() => navigate(`${baseUrl}/todo/callback`)}
        />
        <CasDisplayField
          horizontal
          label="Ten days or less left to sign"
          value={tenDaysLeftCount}
          onClick={() =>
            navigate(
              `${baseUrl}/search?${new URLSearchParams({
                daysLeftLessThan: '10',
                status: ClaimStatusFilter_NotDoneOrAttached,
              })}`
            )
          }
        />

        <CasRefreshButton refetch={refetch} />
      </div>
    </CasStackRow>
  );
}
